import { useState } from "react";
import { Modal } from "rsuite";
import { callFunctionIfExists } from "../../../utils/GeneralUtils";
import { UppyFileInterface } from "../../../components/Inputs/UppyFile";

const FeedbackMediaPreview = ({
  file,
  readonly = false,

  removeFile,
}: {
  file: UppyFileInterface;
  readonly?: boolean;
  openModal?: boolean;
  tenantID?: string;
  removeFile?: () => void;
}) => {
  const [modalopen, setModalOpen] = useState(false);
  const fileURL = file?.PublicURL;
  const fileType = file.Type.split("/")[0];

  return (
    <>
      <div style={{ height: "56px" }} className="d-flex align-items-center ">
        {!readonly && (
          <i
            style={{
              position: "relative",
              top: "-30px",
              right: "-45px",
              fontSize: "14px",
              width: "0px",
              height: "0px",
            }}
            onClick={(e) => {
              e.preventDefault();
              callFunctionIfExists(removeFile);
            }}
            className="mdi mdi-close-circle-outline cursor-pointer m-0 p-0"
          />
        )}

        {fileType === "video" && (
          <video
            src={fileURL}
            onClick={() => setModalOpen(true)}
            controls={false}
            className="mdi mdi-video text-primary"
            style={{
              fontSize: "24px",
              marginRight: "8px",
              cursor: "pointer",
              width: "52px",
              height: "38px",
            }}
          />
        )}
        {fileType === "image" && (
          <img
            src={fileURL}
            alt={file.AltText}
            onClick={() => setModalOpen(true)}
            className="cursor-pointer"
            style={{
              width: "52px",
              height: "38px",
              objectFit: "contain",
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
              borderRadius: "5px",
              background: "var(--ultralight)",
              padding: `${readonly ? "0px" : "4px"}`,
            }}
          />
        )}
      </div>
      <Modal open={modalopen} onClose={() => setModalOpen(false)}>
        <Modal.Header>
          <Modal.Title className="pt-3 pl-3 h2">Media Preview</Modal.Title>
        </Modal.Header>
        <div className="p-4 w-100 d-flex justify-content-center">
          {fileType === "video" && (
            <video
              style={{ maxWidth: "100%", maxHeight: "calc(100vh - 300px)" }}
              controls
              src={fileURL}
            />
          )}
          {fileType === "image" && (
            <img
              style={{ maxWidth: "100%", maxHeight: "calc(100vh - 300px)" }}
              src={fileURL}
              alt=""
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default FeedbackMediaPreview;
